var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcEmailVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 441,
    viewBox: "0 0 594 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377.013 70.3333C418.391 57.2667 446.419 84.6667 455.261 100C477.807 30.6666 429.399 1.66667 388.617 12C345.846 21 326.173 10.8889 317 0C319.763 28.8889 335.634 83.4 377.013 70.3333Z",
    fill: "#21325B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.044 70C346.36 97.4919 340.402 156.171 386.044 170.95C405.501 175.569 433.532 165.012 444.085 137.96L452 120.475",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M452 103.077C454.084 99.8414 459.062 95.4603 462.299 103.824C465.536 112.188 456.782 118.76 452 121",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M456 106C456.7 106.667 457.726 108.6 456.233 111",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M389 90C388.333 94.7458 385.2 105.39 378 110",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388 116C387.14 114 382.645 110.533 378 110",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M410 82.0053C413.382 81.8987 420.717 83.3484 423 90",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M359 88C359.625 85.2335 362.5 79.7621 369 80.008",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 91.5,
    rx: 3,
    ry: 4.5,
    fill: "#21325B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 413,
    cy: 97.5,
    rx: 3,
    ry: 3.5,
    fill: "#21325B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M442 168C474.661 179.177 546.228 211.49 571.205 251.328C596.183 291.166 568.216 310.753 544.966 318.057L499.794 332",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M380.333 170.242L378 191.636M446.333 137L438.667 183.736M367 190.319C380.667 194.049 416.6 196.77 451 177.812",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M349.989 241C330.711 263.846 321.256 355.499 340.682 421.784C359.295 436.683 399.512 450.921 496.565 417.81C501.55 413.837 501.251 416.142 500.719 394.73C500.053 367.966 500.386 308.172 493.4 277.422",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M578.366 293C589.339 306.556 600.225 349.2 578.366 374C556.506 398.8 517.68 423 501 432M501 367.333L529.642 335.667C531.507 333.444 534.58 327.6 531.946 322",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M378 171.196C357.099 169.328 317.895 174.559 278.938 194.735C261.623 203.702 219.797 212.967 191.006 178.295C188.038 174.933 184.698 170.076 183.956 164.845C183.446 161.245 179.628 158.742 177.278 158.867M177.649 164.845C177.649 162.105 177.872 156.7 171.342 156.999M172.826 162.229C171.836 159.365 169.034 153.935 163.988 156.625M168.745 165.592C167.137 164.596 165.034 160.511 163.55 155.131C162.066 149.75 154.275 145.167 150.565 143.548C148.586 142.677 144.628 142.203 144.628 147.285C144.628 151.768 155.536 155.654 156.13 162.229C156.724 168.805 156.377 171.695 156.13 172.317C155.512 173.563 153.31 175.082 149.452 171.196C145.593 167.311 140.547 166.339 137.95 167.087C135.724 167.834 132.607 170.374 137.95 174.559C141.919 177.668 154.943 183.451 166.519 198.097C178.094 212.743 192.614 228.361 198.426 234.338C210.423 244.924 243.32 263.78 278.938 254.514",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M378 139.075C381.595 142.073 391.249 144.564 397 137",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M283.801 201C284.334 212.163 284.121 240.392 279 264",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M279 264.176C292.339 266.306 327.548 265.791 363 244",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M271 256C272.333 258.625 275.364 262 279 262",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165 123.384C165 104.33 150.225 88.884 132 88.884C113.775 88.884 99 104.33 99 123.384C99 135.884 105.359 146.832 114.88 152.884",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122 121.74L130.5 130.24",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.5 130.24L143 115.24",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100 148.694C96.1593 152.535 92.8486 155.846 90.5678 158.126C84.622 164.072 78.3785 160.604 76 158.126L38.0678 121.626C32.4678 116.426 27.7345 111.293 6.56779 91.1264C4.40112 88.9597 0.967786 83.4264 4.56779 78.6264C8.16779 73.8264 28.4011 48.6264 38.0678 36.6264C41 32.384 47.3721 27.3367 55.5 34.884C62.5 41.384 86.5 63.884 107 80.9906",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 37.384C38.6959 59.3081 46.7653 94.6012 88.5 107.884",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcEmailVerification);
export default __webpack_public_path__ + "static/media/oc-email-verification.1badc7cc20915d4ffc76e8c55353fd29.svg";
export { ForwardRef as ReactComponent };